export const env = {
  API_URL: process.env.API_URL,
  WS_URL: process.env.WS_URL,
  TELEGRAM_MINIAPP_LINK: process.env.TELEGRAM_MINIAPP_LINK,
  APP_NAME: 'Pure Win',
  ENVIRONMENT: process.env.ENVIRONMENT,
  TON_WALLET_ADDRESS: process.env.TON_WALLET_ADDRESS as string,
  TON_NETWORK: process.env.TON_NETWORK as 'testnet' | 'mainnet',
};
